import { makeStyles } from '@material-ui/core';
import CustomLogoFull from './logo/logo-ntt-blue.png';

const useStyles = makeStyles({
  png: {
    width: 160,
    height: 33,
    filter: 'brightness(0) invert(1)',
    opacity: 0.92,
    display: 'block',
  },
});

const LogoFull = () => {
  const classes = useStyles();
  return <img src={CustomLogoFull} className={classes.png} alt="NTT Data" />;
};

export default LogoFull;
